export const AUTH_COPY = {
    subtitle: 'Il gestionale di BeSuites: i clienti, i lavori, i conti e i sistemi, in un posto solo.',
    identityNote: 'L’accesso è gestito da beAuth, il sistema di identità della piattaforma.',
} as const;

export const HIGHLIGHTS = [
    { title: 'Clienti', body: 'Aziende, professionisti, privati ed enti pubblici, con le regole di fatturazione già pronte.' },
    { title: 'Lavoro', body: 'Lavagna, calendario e scadenze: cosa è in corso e cosa aspetta.' },
    { title: 'Sistemi', body: 'Traffico del gateway, chiavi, accessi: la piattaforma vista da dentro.' },
] as const;
